export default __webpack_public_path__ + "static/media/background.afb4a047.png";